/**
 * Only for global mixin. For component mixin please write it on separate file.
 */

import {
 filterMoney, filterToday, filterWeek, filterText
} from '../helper/filterMethods';
import getParamsVal from '../helper/getParamsVal';

export default {
  methods: {
    filterMoney,
    filterToday,
    filterWeek,
    getParamsVal,
    filterText
  }
};
